import { useThemeColor } from '@wistia/vhs';
import type { JSX } from 'react';

export const GoodConnectionIcon = (): JSX.Element => {
  const color = useThemeColor('warning500');

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="14"
        width="3"
        height="4"
        rx="1.5"
        fill={color}
      />
      <rect
        x="6.33334"
        y="10"
        width="3"
        height="8"
        rx="1.5"
        fill={color}
      />
      <rect
        x="10.6667"
        y="6"
        width="3"
        height="12"
        rx="1.5"
        fill="#DEDEE1"
      />
      <rect
        x="15"
        y="2"
        width="3"
        height="16"
        rx="1.5"
        fill="#DEDEE1"
      />
    </svg>
  );
};
